const shortUuid = () => {
  return crypto.randomUUID().split('-')[0];
};

export default shortUuid;
